import { ImgVideoProps } from 'eco-design-micro/props/img/ImgVideoProps';
import EcoImg from 'eco-design/base/eco-img';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import EcoLink from 'eco-design/base/eco-link';
import React from 'react';
import './card.scss';

export interface EcoBlogItemProps extends ImgVideoProps {
    /**
     * 文章详情链接
     */
    href?: string;
    /**
     * 文章分组链接
     */
    categoryHref?: string;
    /**
     * 用户图标
     */
    userIcon?: string;
    /**
     * 用户名称
     */
    userName?: string;
    /**
     * 博客时间
     */
    timer?: string;
    /**
     * 标题上的标签
     */
    label?: React.ReactNode;
    /**
     * 标题上的标签-字体颜色
     */
    labelColor?: string;
    /**
     * 标题
     */
    title?: React.ReactNode;
    /**
     * 标题-字体颜色
     */
    titleColor?: string;
}

// 默认用户头像
const defaultUserIcon = 'https://websiteoss.ecoflow.com/upload/image/1735782674645/logo.svg';
/**
 * 博客列表(标题 + 描述)
 */
const EcoBlogCard: React.FC<EcoBlogItemProps> = ({ ...reset }) => {
    const item = reset || {};
    const prefixCls = `eco-blog-items-card`;
    const itemStyleComp = {
        '--blog-item-titleColor': item.titleColor,
        '--blog-item-labelColor': item.labelColor,
    } as React.CSSProperties;

    return (
        <div className={`${prefixCls}`} style={itemStyleComp}>
            <EcoLink href={item.href} className={`${prefixCls}-img`}>
                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} />
            </EcoLink>
            <div className={`${prefixCls}-msg`}>
                <EcoLink href={item.categoryHref} className={`${prefixCls}-label`}>
                    {item.label}
                    <div className={`${prefixCls}-msg-time`}>{item.timer}</div>
                </EcoLink>
                <EcoLink href={item.href} className={`${prefixCls}-title`}>
                    {item.title}
                </EcoLink>
                <div className={`${prefixCls}-footer`}>
                    <div className={`${prefixCls}-footer-icon`}>
                        <EcoImg pc={item.userIcon || defaultUserIcon} />
                    </div>
                    <div className={`${prefixCls}-footer-logo`}>{item.userName || 'EcoFlow'}</div>
                    <div className={`${prefixCls}-footer-time`}>{item.timer}</div>
                </div>
            </div>
        </div>
    );
};

export default EcoBlogCard;
